var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinFlat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.9998 11.4823C28.0267 8.15762 22.1247 5.40677 14.8172 5.33809C7.50972 5.26942 1.564 7.90891 1.53706 11.2336C1.51012 14.5582 7.41216 17.3091 14.7196 17.3778C22.0271 17.4465 27.9728 14.807 27.9998 11.4823Z",
    fill: "#FF7C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.0313 6.98842L1.58594 6.73828L1.54837 11.4044L27.9937 11.6546L28.0313 6.98842Z",
    fill: "#FF7C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.52881 6.7373L1.49275 11.2749C1.49275 11.2749 1.33258 14.0523 6.40319 15.9618L6.60474 11.0831C6.60474 11.0831 2.35179 9.39542 1.52909 6.73761L1.52881 6.7373Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2711_551775",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 5,
    width: 27,
    height: 13
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.9581 11.5171C27.9857 8.19248 22.0842 5.44301 14.7767 5.37604C7.46925 5.30907 1.52296 7.94994 1.49534 11.2746C1.46771 14.5993 7.3692 17.3487 14.6767 17.4157C21.9842 17.4827 27.9305 14.8418 27.9581 11.5171Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2711_551775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6257 7.99907L13.5234 7.96973L13.4387 18.4924L16.541 18.5218L16.6257 7.99907Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0637 7.92416L17.75 7.85498L17.6653 18.3777L24.9789 18.4468L25.0637 7.92416Z",
    fill: "white"
  })))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M28.0257 6.9876C28.0512 3.81906 22.1399 1.19433 14.8224 1.12511C7.50487 1.0559 1.55217 3.56841 1.52666 6.73695C1.50115 9.9055 7.41248 12.5302 14.73 12.5994C22.0475 12.6687 28.0002 10.1562 28.0257 6.9876Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M14.8293 12.3258C7.59583 12.257 1.73691 9.69104 1.62789 6.57178C1.62397 6.62571 1.62174 6.67994 1.62118 6.73448C1.59546 9.90313 7.50666 12.5282 14.8242 12.5976C22.1418 12.6673 28.0947 10.1549 28.1201 6.98657C28.1204 6.95021 28.1195 6.91385 28.1184 6.87749C27.8945 9.96888 22.021 12.3943 14.8293 12.3258Z",
    fill: "url(#paint0_linear_2711_551775)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M24.0882 6.64006C24.1044 4.61604 19.9649 2.93597 14.8422 2.88752C9.71957 2.83906 5.55362 4.44057 5.53732 6.46459C5.52102 8.48861 9.66056 10.1687 14.7832 10.2171C19.9059 10.2656 24.0719 8.66407 24.0882 6.64006Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M14.8144 2.87861C19.8056 2.92618 23.8629 4.52262 24.0524 6.47659C24.0583 6.42539 24.0622 6.37388 24.0625 6.32177C24.079 4.29781 19.9395 2.61774 14.8169 2.56896C9.69429 2.52018 5.52828 4.12147 5.51178 6.14543C5.51122 6.19724 5.5143 6.24905 5.51933 6.30026C5.74073 4.35022 9.82288 2.83104 14.8144 2.87861Z",
    fill: "url(#paint1_linear_2711_551775)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M14.8717 3.40349C19.6502 3.44894 23.5724 4.91419 24.0647 6.75363C24.0678 6.71606 24.07 6.67849 24.0703 6.64062C24.0868 4.61665 19.9473 2.93659 14.8247 2.8878C9.70209 2.83902 5.53607 4.44031 5.51958 6.46428C5.51846 6.60032 5.53663 6.73454 5.57213 6.86725C5.7393 4.89722 9.84466 3.35592 14.8714 3.40379L14.8717 3.40349Z",
    fill: "#CB6300"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M13.7978 3.88395L11.2615 3.87305L11.255 5.63462L13.7913 5.64553L13.7978 3.88395ZM13.7978 3.88395L11.2615 3.87305L11.255 5.63462L13.7913 5.64553L13.7978 3.88395ZM13.7849 7.40801L11.2486 7.3971L11.2422 9.15868L13.7785 9.16958L13.7849 7.40801ZM13.7849 7.40801L11.2486 7.3971L11.2422 9.15868L13.7785 9.16958L13.7849 7.40801ZM13.7924 5.64553L13.786 7.4071L16.3223 7.41801L16.3159 9.18019L18.8522 9.1911L18.8586 7.42892L18.865 5.66734L16.3287 5.65644L13.7924 5.64553ZM13.7924 5.64553L13.786 7.4071L16.3223 7.41801L16.3159 9.18019L18.8522 9.1911L18.8586 7.42892L18.865 5.66734L16.3287 5.65644L13.7924 5.64553Z",
    fill: "#C15900"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M28.0722 6.99052H28.0702C28.096 3.82187 22.1848 1.19678 14.8672 1.12739C7.5496 1.0577 1.59675 3.57008 1.57131 6.73843C1.56991 6.91689 1.58752 7.09353 1.62274 7.26805L1.59479 10.7236C1.55677 10.9054 1.53665 11.0896 1.53525 11.276C1.50841 14.6007 7.41039 17.3521 14.7179 17.4218C19.9889 17.4721 24.5514 16.1129 26.6949 14.1038C27.5506 13.3175 28.0342 12.4298 28.0417 11.4872C28.0423 11.4281 28.0406 11.369 28.0372 11.3105L28.0722 6.99082V6.99052Z",
    stroke: "#771B00",
    strokeWidth: 1.12257,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2711_551775",
    x1: 1.59991,
    y1: 9.52179,
    x2: 28.0992,
    y2: 9.73515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2711_551775",
    x1: 5.52723,
    y1: 4.39031,
    x2: 24.0783,
    y2: 4.53967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinFlat);
export default __webpack_public_path__ + "static/media/coin-flat.c148970f92ff658f66869f49804fd1af.svg";
export { ForwardRef as ReactComponent };